import { formatUrl } from '@monash/portal-frontend-common';
import { flattenFieldArray } from './transform-field-array';

const transformLinksForSubmission = (links = []) =>
  links.map(({ text, url }) => ({
    text,
    url: url ? formatUrl(url) : url,
  }));

const transformImageForSubmission = (imageUrl) => {
  if (!imageUrl) return undefined;

  return { url: formatUrl(imageUrl) };
};

// General transform that applies to all submit types. Implement submit type-specific transforms
// in their respective submit handlers if applicable
export const transformLinkForSubmission = (data) => {
  const {
    startTime: _startTime, // The startTime field is incorporated into startDate
    links,
    imageUrl,
    tags,
    filters,
    personalisationTags,
    relevance,
    ...restData
  } = data;

  return {
    ...restData,
    url: links?.[0]?.url ?? '', // TODO: This is for backwards compatibility and can be removed after we migrate all of the links to the honeycomb schema
    links: transformLinksForSubmission(links),
    image: transformImageForSubmission(imageUrl),
    tags: flattenFieldArray(tags),
    filters: flattenFieldArray(filters),
    personalisationTags: flattenFieldArray(personalisationTags),
    relevance: Number.isInteger(relevance) ? relevance : null,
  };
};
